import React, { useCallback, useEffect, useState } from 'react';
import { useNotification } from '../context/NotificationContext';

const WebhookEventLog = ({ apiBase = 'http://localhost:4000' }) => {
  const [events, setEvents] = useState([]);
  const [polling, setPolling] = useState(false);
  const { addNotification } = useNotification();

  const fetchEvents = useCallback(async () => {
    try {
      const res = await fetch(`${apiBase}/api/webhooks/events?limit=10`);
      if (!res.ok) throw new Error(`HTTP ${res.status}`);
      const data = await res.json();
      setEvents(data || []);
    } catch (e) {
      console.warn('Failed to fetch webhook events', e.message);
    }
  }, [apiBase]);

  useEffect(() => {
    fetchEvents();
  }, [fetchEvents]);

  useEffect(() => {
    if (!polling) return;
    const interval = setInterval(fetchEvents, 2000);
    return () => clearInterval(interval);
  }, [fetchEvents, polling]);

  const handleClear = async () => {
    try {
      await fetch(`${apiBase}/api/webhooks/events`, { method: 'DELETE' });
      setEvents([]);
      addNotification('Event log cleared', 'info');
    } catch (e) {
      addNotification('Failed to clear events', 'error');
    }
  };

  return (
    <div className="card mt-3">
      <div className="card-header d-flex justify-content-between align-items-center">
        <strong>Webhook Events</strong>
        <div>
          <button
            className={`btn btn-sm ${polling ? 'btn-warning' : 'btn-outline-primary'}`}
            onClick={() => setPolling(!polling)}
          >
            {polling ? '⏸ Stop' : '▶ Monitor'}
          </button>
          <button
            className="btn btn-sm btn-outline-secondary ms-2"
            onClick={handleClear}
          >
            Clear
          </button>
        </div>
      </div>
      <div className="card-body" style={{ maxHeight: 300, overflowY: 'auto' }}>
        {events.length === 0 ? (
          <p className="text-muted">No events yet. Enable monitoring or send a webhook.</p>
        ) : (
          <table className="table table-sm mb-0">
            <thead>
              <tr>
                <th style={{ width: 180 }}>Timestamp</th>
                <th style={{ width: 120 }}>Event</th>
                <th>Data</th>
              </tr>
            </thead>
            <tbody>
              {events.map(e => (
                <tr key={e.id}>
                  <td className="small">{new Date(e.timestamp).toLocaleTimeString()}</td>
                  <td className="small"><strong>{e.event}</strong></td>
                  <td className="small text-muted">{JSON.stringify(e.data).slice(0, 60)}…</td>
                </tr>
              ))}
            </tbody>
          </table>
        )}
      </div>
    </div>
  );
};

export default WebhookEventLog;
